<div class="kpi-nested-container">
  <div class="kpi-nested-content">
    <div class="left-icon">
      <app-icon [svgIcon]="icon()" class="icon-large"></app-icon>
    </div>
    <div class="right-content">
      <div class="content-wrapper">
        <div class="top-container">
          <div class="label-container">
            <p class="label-text">{{ label() }}</p>
          </div>
          @if (infoTooltip()) {
            <div class="info-icon">
              <app-icon
                [svgIcon]="IconsEnum.info"
                [matTooltip]="infoTooltip()!"
                class="icon-small">
              </app-icon>
            </div>
          }
        </div>
        <div class="bottom-container">
          <div class="value-row">
            <span class="value-number">{{ displayValue() }}</span>
            @if (subValue() && !isNotAvailable()) {
              <span class="max-value-number">{{ subValue() }}</span>
            }
          </div>
        </div>
        @if (progressBarType() === 'stacked') {
          <div class="bar-wrapper">
            <app-ui-stacked-progress-bar
              [segments]="stackedBarSegments() ?? []"
              [height]="6"
              [matTooltip]="tooltipValue()"
              [matTooltipDisabled]="!tooltipValue()"
              class="progress-bar-full-width">
            </app-ui-stacked-progress-bar>
          </div>
        } @else if (progressBarType()) {
          <div class="bar-wrapper">
            <app-ui-progress-bar
              [type]="progressBarType()"
              [value]="progressBarValue() ?? value()"
              [vprScore]="vprScore() ?? undefined"
              [riskScore]="riskScore() ?? undefined"
              [criticality]="criticality() ?? undefined"
              [height]="6"
              [showNumber]="false"
              [matTooltip]="tooltipValue()"
              [matTooltipDisabled]="!tooltipValue()"
              class="progress-bar-full-width">
            </app-ui-progress-bar>
          </div>
        }
      </div>
    </div>
  </div>
</div>

